import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppContainerService, AppRightDrawerService, SideNavBarService } from '@mydocma/app-container';
import { UntilDestroy, untilDestroyed,  } from '@ngneat/until-destroy';
import { combineLatest } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'mydocma-mm-task-dashboard',
  templateUrl: './mm-task-dashboard.component.html',
  styleUrls: ['./mm-task-dashboard.component.scss']
})
export class MmTaskDashboardComponent implements OnInit, OnDestroy {


  constructor(private readonly appRightDrawerService: AppRightDrawerService,
              public appContainerService:AppContainerService,
              public readonly sideNavbarService: SideNavBarService) {

    combineLatest([
      this.appContainerService.mobileView$,
      this.appRightDrawerService.isOpen
    ])
    .pipe(untilDestroyed(this))
    .subscribe(([isMobile,isOpen]) => {

      this.sideNavbarService.barVisibility = !(isMobile && isOpen);

    });
  }
  ngOnDestroy(): void {
  }

  ngOnInit() {

  }

  onCloseClick() {
      this.appRightDrawerService.close();
  }
}
